export const USE_MOCK_MAINTENANCE_LOG = true;

export const MOCK_MAINTENANCE_LOG_TASKS = [
  {
    id: "MOCK-CAL-001",
    task_id: "MOCK-CAL-001",
    code: "ME-001-001",
    ship_id: 1,
    ship_name: "MV Demo Voyager",
    machinery_id: 101,
    machinery_name: "Main Engine",
    task_type: "calendar",
    maintenance_type: "calendar",
    job_description: "Inspect main engine lube oil filters and record condition.",
    frequency_type: "monthly",
    frequency_value: 1,
    last_date_done: "2026-03-30",
    due_date: "2026-04-30",
    next_due_date: "2026-04-30",
    priority: "Medium",
    status: "pending",
    assigned_to: "Chief Engineer",
    remarks: "Generated from monthly calendar maintenance rule.",
  },
  {
    id: "MOCK-RH-001",
    task_id: "MOCK-RH-001",
    code: "DG-002-001",
    ship_id: 1,
    ship_name: "MV Demo Voyager",
    machinery_id: 202,
    machinery_name: "Diesel Generator No. 1",
    task_type: "running_hours",
    maintenance_type: "running_hours",
    job_description: "Replace fuel filter after running-hours interval.",
    last_done_hours: 1500,
    interval_hours: 500,
    due_hours: 2000,
    next_due_hours: 2000,
    current_counter_reading: 2015,
    priority: "High",
    status: "overdue",
    assigned_to: "Second Engineer",
    remarks: "Generated because current counter crossed the 2000 hour due point.",
  },
];
